import { Component, ViewChild, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from '../../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from '../../../components/toast/toast.service';
import { UploadingFile } from '../uploader.component';
import { SearchService } from '../../../services/search.service';
import Utils from '../../../services/utils';

@Component({
  selector: 'lowy-metabolomic-meta',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Edit Metabolomic Metadata</div>
      <div class="subheading">After adding the metabolomic's metadata, please hit the save button to move the file into your complete queue.
      </div>
      <div class="seperator"></div>
      <div class="icon-label-row">
        <div class="data-icon-clear metabolomic"><i class="material-icons">flash_on</i></div>
        <div class="headline">{{file?.fileName}}</div>
      </div>
      <form [formGroup]="metabolomicMetaForm" (ngSubmit)="save()">
        <mat-form-field>
          <input matInput placeholder="Patient ID" formControlName="patientId" type="text">
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="File Type" formControlName="metabolomicFileType" >
            <mat-option *ngFor="let metabolomicFileType of metabolomicFileTypes" [value]="metabolomicFileType">
              {{metabolomicFileType}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <div class="seperator"></div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span (click)="metabolomicMetaForm.valid && save()"
          [ngClass]="{disabled: metabolomicMetaForm.invalid}">{{saveText}}</span>
      </div>
    </div>
  </lowy-modal>
  `,
  providers: [ SearchService ]
})
export class MetabolomicMetaComponent implements OnInit {
  public metabolomicMetaForm: FormGroup;
  public file: UploadingFile;
  public metabolomicFileTypes: Array<string>;

  @ViewChild('modal') modal: ModalComponent;

  @Output() onSave: EventEmitter<any>;
  @Input('saveText') saveText: string;

  private previouslySavedForm: {
    metabolomicFileType: string
  };

  constructor(private formBuilder: FormBuilder, private toastService: ToastService, private searchService: SearchService) {
    this.metabolomicMetaForm = this.formBuilder.group({
      patientId: [''],
      metabolomicFileType: ['']
    });

    this.onSave = new EventEmitter();
  }

  async ngOnInit() {
    // get allowed file types for metabolomics
    const dataGroups = await this.searchService.getDataGroups();
    dataGroups.forEach(dataGroup => {
      if (dataGroup.spreadsheetId === 'METABOLOMICS') {
        dataGroup.columns.forEach(column => {
          if (column.columnId === 'FILETYPE') {
            this.metabolomicFileTypes = column.possibleValues;
          }
        });
      }
    });
  }

  public async open(file: UploadingFile) {
    this.file = file;
    this.buildForm();
    // wait for self to be closed and hidden, because parent caller will sometimes try to open me up too fast
    while (this.modal.visible) {
      await Utils.sleep(150);
    }
    this.modal.open();
  }

  async buildForm() {
    this.metabolomicMetaForm = this.formBuilder.group({
      patientId: [{ value: this.file.patientId, disabled: true }, Validators.required],
      metabolomicFileType: [null, Validators.required]
    });

    if (this.previouslySavedForm) {
      this.metabolomicMetaForm.setValue({
        patientId: this.file.patientId,
        metabolomicFileType: this.previouslySavedForm.metabolomicFileType
      });
    }
  }

  async save() {
    try {
      this.file.meta = {
        'FILETYPE': this.metabolomicMetaForm.value.metabolomicFileType
      };
      this.previouslySavedForm = {
        metabolomicFileType: this.metabolomicMetaForm.value.metabolomicFileType
      };
      this.onSave.emit(this.file);
      this.modal.close();
    }
    catch (err) {
      this.modal.close();
      this.toastService.throwToast('Error saving metabolomic data');
    }
  }

  public clearSaved() {
    this.previouslySavedForm = null;
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/uploader/modals/metabolomic-meta-modal.component.ts